import { render, staticRenderFns } from "./dictListItem.vue?vue&type=template&id=8a7a3df6&scoped=true&"
import script from "./dictListItem.vue?vue&type=script&lang=js&"
export * from "./dictListItem.vue?vue&type=script&lang=js&"
import style0 from "./dictListItem.vue?vue&type=style&index=0&id=8a7a3df6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7a3df6",
  null
  
)

export default component.exports